import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.45);
  }
  70% {
    box-shadow: 0 0 0 18px rgba(34, 197, 94, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(7, 10, 18, 0.92);
  backdrop-filter: blur(8px);
`;

export const Panel = styled.div`
  width: min(100%, 360px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #fff;
`;

export const Header = styled.div`
  margin-bottom: 28px;

  span {
    display: block;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.72);
    margin-bottom: 6px;
  }

  strong {
    display: block;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
  }
`;

export const StatusRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 13px;
  color: #86efac;
`;

export const StatusDot = styled.span<{ $live?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $live }) => ($live ? "#22c55e" : "#fbbf24")};
  box-shadow: ${({ $live }) =>
    $live ? "0 0 10px rgba(34, 197, 94, 0.8)" : "none"};
`;

export const AvatarWrap = styled.div`
  position: relative;
  width: 132px;
  height: 132px;
  margin-bottom: 18px;

  &::before {
    content: "";
    position: absolute;
    inset: -8px;
    border-radius: 50%;
    border: 2px solid rgba(34, 197, 94, 0.35);
    animation: ${pulse} 2s infinite;
  }
`;

export const Avatar = styled.div<{ $photo?: boolean }>`
  width: 132px;
  height: 132px;
  border-radius: 50%;
  overflow: hidden;
  background: ${({ $photo }) =>
    $photo ? "transparent" : "linear-gradient(135deg, #005cac, #0284c7)"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  border: 3px solid rgba(34, 197, 94, 0.5);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContactMeta = styled.div`
  margin-bottom: 10px;

  strong {
    display: block;
    font-size: 18px;
    margin-bottom: 4px;
  }

  span {
    display: block;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.62);
  }
`;

export const Timer = styled.div`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #4ade80;
  margin-bottom: 36px;
  font-variant-numeric: tabular-nums;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
`;

export const SecondaryControls = styled.div`
  display: flex;
  gap: 18px;
  justify-content: center;
`;

export const IconButton = styled.button<{ $active?: boolean }>`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: ${({ $active }) =>
    $active ? "rgba(34, 197, 94, 0.2)" : "rgba(255, 255, 255, 0.08)"};
  color: ${({ $active }) => ($active ? "#86efac" : "#fff")};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const HangUpButton = styled.button`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: none;
  background: #ef4444;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.35);
  transition: transform 0.15s ease, background 0.15s ease;

  &:hover {
    background: #dc2626;
    transform: scale(1.04);
  }
`;

export const HangUpLabel = styled.span`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82);
`;
